import _root_default from "./_root.js";

//#region ../../node_modules/lodash-es/_coreJsData.js
/** Used to detect overreaching core-js shims. */
var coreJsData = _root_default["__core-js_shared__"];
var _coreJsData_default = coreJsData;

//#endregion
export { _coreJsData_default as default };
//# sourceMappingURL=_coreJsData.js.map